// Importações do React e bibliotecas necessárias
import React from "react";
import style from "./signin.module.css";

// Componentes e função para exibir notificações toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Hooks customizados
import { useLoginForm } from "./hooks/useLoginForm";
import { useAuth } from "./hooks/useAuth";

// Componentes
import LoginForm from "./components/LoginForm";
import LogoSection from "./components/LogoSection";

/**
 * Componente Signin - Página de autenticação/login
 * 
 * Componente principal que orquestra o processo de login.
 * Utiliza hooks customizados e componentes menores para manter
 * o código organizado e reutilizável.
 * 
 * Funcionalidades:
 * - Login online (via API)
 * - Login offline (via localStorage)
 * - Validação de formulário
 * - Gerenciamento de estado do formulário
 * - Feedback visual (loading, erros)
 */
function Signin() {
  // Hook para gerenciar estado do formulário
  const {
    formData,
    errors,
    showPassword,
    updateField,
    setErrors,
    togglePasswordVisibility
  } = useLoginForm();

  // Hook para gerenciar autenticação
  const { login, loading } = useAuth();

  /**
   * Handler de submissão do formulário
   * @param {Event} e - Evento de submit do formulário
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Realiza o login
    const result = await login(
      formData.user,
      formData.password
    );

    // Se houver erros de validação, atualiza o estado de erros
    if (!result.success && result.errors) {
      setErrors(result.errors);
    }
    // Se houver erro geral (sem erros específicos de campo), 
    // os erros já foram tratados no hook useAuth (toast)
  };

  return (
    <div className={style["main-container"]}>
      <main className={style.container}>
        {/* Seção de logos */}
        <LogoSection />

        {/* Título da página */}
        <h2>Login</h2>

        {/* Formulário de login */}
        <LoginForm
          formData={formData}
          errors={errors}
          showPassword={showPassword}
          onFieldChange={updateField}
          onTogglePassword={togglePasswordVisibility}
          onSubmit={handleSubmit}
          loading={loading}
        />

        {/* Container para exibir notificações toast */}
        <ToastContainer />
      </main>
    </div>
  );
}

// Exporta o componente como padrão
export default Signin;
